<template>
    <div style="width: 100%;">
        <div style="background: #ffffff; border-radius: 20px; padding: 18px 16px 16px; box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px;">
                <div style="font-weight: 900; font-size: 16px; line-height: 20px; color: #210f03;">내 스카웃 현황</div>
                <div
                    :style="badgeStyle"
                    style="font-weight: 700; font-size: 12px; padding: 6px 10px; border-radius: 8px;"
                >
                    {{ badgeText }}
                </div>
            </div>

            <!-- 이적시장 스카우트 -->
            <div style="margin-top: 14px;">
                <div style="font-weight: 900; font-size: 14px; line-height: 20px; color: #210f03; margin-bottom: 8px;">이적시장 스카우트</div>

                <template v-if="hasTeam">
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                        <div style="font-weight: 500; font-size: 12px; color: #b0b0b0;">사용 완료 {{ usedTrade }}회</div>
                        <div style="font-weight: 900; font-size: 12px; color: #ff7111;">남은 횟수 {{ remainTrade }}회</div>
                    </div>
                </template>

                <div class="bar">
                    <div class="bar-blocks-area" aria-hidden="true">
                        <div class="blocks">
                            <div
                                v-for="i in tradeTotal"
                                :key="'t-' + i"
                                class="block trade-block"
                                :class="i <= remainTrade ? 'trade-on' : 'off'"
                            ></div>
                        </div>
                    </div>
                    <div class="bar-hatch-area" :style="hatchStyle">
                        <div class="hatch-text">{{ barOverlayText }}</div>
                    </div>
                </div>
            </div>

            <!-- 그라운드 스카우트 -->
            <div style="margin-top: 14px;">
                <div style="font-weight: 900; font-size: 14px; line-height: 20px; color: #210f03; margin-bottom: 8px;">그라운드 스카우트</div>

                <template v-if="hasTeam">
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                        <div style="font-weight: 500; font-size: 12px; color: #b0b0b0;">사용 완료 {{ usedGround }}회</div>
                        <div style="font-weight: 900; font-size: 12px; color: #2b6cff;">남은 횟수 {{ remainGround }}회</div>
                    </div>
                </template>

                <div class="bar">
                    <div class="bar-blocks-area" aria-hidden="true">
                        <div class="blocks">
                            <div
                                v-for="i in groundTotal"
                                :key="'g-' + i"
                                class="block"
                                :class="i <= remainGround ? 'ground-on' : 'off'"
                            ></div>
                        </div>
                    </div>
                    <div class="bar-hatch-area" :style="hatchStyle">
                        <div class="hatch-text">{{ barOverlayText }}</div>
                    </div>
                </div>
            </div>

            <div v-if="hasTeam && showNextCharge" style="margin-top: 10px; font-weight: 700; font-size: 12px; color: #b0b0b0;">
                다음 충전 예정일: {{ nextChargeText }}
            </div>
            <div v-if="hasTeam && showPeriod" style="margin-top: 10px; font-weight: 700; font-size: 12px; color: #b0b0b0;">
                요금제 이용 기간(30일): {{ periodText }}
            </div>

            <div
                v-if="!hasTeam"
                @click="onClickTeamRegister"
                style="margin-top: 14px; width: 100%; height: 56px; border-radius: 14px; background: #210f03; color: #ffffff; font-weight: 900; font-size: 14px; display: grid; place-items: center;"
            >
                팀 등록하러 가기
            </div>

            <div
                v-else-if="isFreePlan"
                @click="onClickUpgrade"
                style="margin-top: 14px; width: 100%; height: 56px; border-radius: 14px; background: #210f03; color: #ffffff; font-weight: 900; font-size: 14px; display: grid; place-items: center;"
            >
                스카우트 요금제 업그레이드
            </div>

            <div
                v-else
                @click="onClickManage"
                style="margin-top: 14px; width: 100%; height: 56px; border-radius: 14px; background: #d9d9d9; color: #210f03; font-weight: 900; font-size: 14px; display: flex; justify-content: center; align-items: center; gap: 8px;"
            >
                <span style="font-size: 16px; line-height: 1;">⚙</span>
                멤버쉽 구독 관리
            </div>
        </div>
    </div>
</template>

<script>
import { MEMBER_POPUP_TYPE } from '@/Constants'

export default {
    name: 'MyCurrentScout',
    props: {
        memberInfo: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        hasTeam() {
            return this.memberInfo && this.memberInfo.team_idx !== null && this.memberInfo.team_idx !== undefined
        },
        plan() {
            const v = this.memberInfo ? this.memberInfo.rate_plan : null
            return v === null || v === undefined || v === '' ? null : String(v).toLowerCase()
        },
        isFreePlan() {
            return this.plan === null
        },
        quota() {
            if (this.plan === 'pro') {
                return { trade: 15, ground: 30 }
            }
            if (this.plan === 'lite') {
                return { trade: 5, ground: 10 }
            }
            return { trade: 1, ground: 5 }
        },
        badgeStyle() {
            if (this.plan === 'lite') {
                return { background: '#e7f0ff', color: '#2b6cff' }
            }
            if (this.plan === 'pro') {
                return { background: '#ffe9db', color: '#ff7111' }
            }
            return { background: '#ededed', color: '#606060' }
        },
        usedTrade() {
            const raw = this.memberInfo?.trade_count ?? this.memberInfo?.trade_scout ?? 0
            return this.toNonNegativeInt(raw)
        },
        usedGround() {
            const raw = this.memberInfo?.ground_scout ?? 0
            return this.toNonNegativeInt(raw)
        },
        remainTrade() {
            return Math.max(0, this.tradeTotal - this.usedTrade)
        },
        remainGround() {
            return Math.max(0, this.groundTotal - this.usedGround)
        },
        tradeTotal() {
            return this.hasTeam ? this.quota.trade : 5
        },
        groundTotal() {
            return this.hasTeam ? this.quota.ground : 5
        },
        badgeText() {
            if (!this.hasTeam) return '무료 요금제'
            if (this.plan === 'lite') return 'Lite 요금제 사용중'
            if (this.plan === 'pro') return 'PRO 요금제 사용중'
            return '무료 요금제'
        },
        barOverlayText() {
            if (!this.hasTeam) return '팀등록이후 이용 가능'
            if (this.isFreePlan) return '요금제 결제 후 사용 가능'
            return 'PRO 결제 후 사용 가능'
        },
        hatchStyle() {
            return {
                background: 'repeating-linear-gradient(135deg, #EEEEEE 0px, #EEEEEE 5px, #F4F5F7 5px, #F4F5F7 10px)'
            }
        },
        nextChargeText() {
            const raw = this.pickFirst(this.memberInfo, [
                'next_charge_date',
                'next_charge_dt',
                'next_payment_date',
                'next_payment_dt',
                'next_rate_plan_date',
                'next_rate_plan_dt'
            ])
            return this.formatDate(raw)
        },
        showNextCharge() {
            return this.isFreePlan && !!this.nextChargeText
        },
        periodText() {
            const startRaw = this.pickFirst(this.memberInfo, [
                'rate_plan_start_date',
                'rate_plan_start_dt',
                'rate_plan_start',
                'plan_start_date'
            ])
            const endRaw = this.pickFirst(this.memberInfo, [
                'rate_plan_end_date',
                'rate_plan_end_dt',
                'rate_plan_end',
                'plan_end_date'
            ])
            const start = this.formatDate(startRaw)
            const end = this.formatDate(endRaw)
            if (!start || !end) return ''
            return `${start} ~ ${end}`
        },
        showPeriod() {
            return !this.isFreePlan && !!this.periodText
        },
    },
    methods: {
        toNonNegativeInt(v) {
            const n = Number(v)
            if (!Number.isFinite(n)) return 0
            return Math.max(0, Math.floor(n))
        },
        pickFirst(obj, keys) {
            if (!obj) return null
            for (const k of keys) {
                const v = obj[k]
                if (v !== null && v !== undefined && v !== '') return v
            }
            return null
        },
        formatDate(raw) {
            if (!raw) return ''
            const s = String(raw).trim()
            if (!s) return ''
            const normalized = s.replaceAll('/', '.').replaceAll('-', '.')
            const m = normalized.match(/^(\d{4})\.(\d{1,2})\.(\d{1,2})/)
            if (!m) return normalized
            const yyyy = m[1]
            const mm = m[2].padStart(2, '0')
            const dd = m[3].padStart(2, '0')
            return `${yyyy}.${mm}.${dd}`
        },
        onClickTeamRegister() {
        },
        onClickUpgrade() {
        },
        onClickManage() {
            this.$GlobalStore.addModal('MemberPopupList', { 
                type: MEMBER_POPUP_TYPE.EXTINCTION,
                isModalBackTransparent: true,
                transitionName: ''
            })
        }
    }
}
</script>

<style scoped>
.bar {
    position: relative;
    height: 30px;
    background: transparent;
    display: flex;
    align-items: stretch;
    gap: 4px;
}

.bar-blocks-area {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    /* padding: 0 10px; */
    /* border-radius: 10px; */
    /* background: #F4F5F7; */
}

.blocks {
    display: flex;
    gap: 4px;
    align-items: center;
}

.block {
    width: 8px;
    height: 30px;
    border-radius: 3px;
    background: #d9d9d9;
    flex: 0 0 auto;
}

.trade-block {
    width: 20px;
}

.block.trade-on {
    background: #ff7111;
}

.block.ground-on {
    background: #2b6cff;
}

.block.off {
    background: #d9d9d9;
}

.bar-hatch-area {
    flex: 1 1 auto;
    display: grid;
    place-items: center;
    border-radius: 10px;
}

.hatch-text {
    font-weight: 900;
    font-size: 12px;
    color: #210f03;
    opacity: 0.85;
}
</style>